/* eslint-disable no-unused-vars */
import { SEARCH } from "./actionTypes";
const initialState = [];

export default function searchReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH:
      if (action.payload.query) {
        return action.payload.books.filter((book) =>
          book.name.toLowerCase().includes(action.payload.query)
        );
      }
      return action.payload.books;

    default:
      return state;
  }
}
